import axios from '@/plugins/axios';
import { useToast } from '@/composables/use-toast.js';
import { logApiError } from '@/services/api.js';
const { addToast } = useToast();

const baseUrl = '/api/draft-listings';

export const fetchDraftListings = async () => {
    try {
        const response = await axios.get(`${baseUrl}`);
        return response.data;
    } catch (error) {
        logApiError(error, 'GET', `${baseUrl}`);

        addToast('Error fetching draft listing', 'error');
        return false;
    }
}

export const fetchDraftListing = async (id) => {
    try {
        const response = await axios.get(`${baseUrl}/${id}`);
        return response.data;
    } catch (error) {
        logApiError(error, 'GET', `${baseUrl}`);

        addToast('Error fetching draft listing', 'error');
        return false;
    }
}

export const fetchDraftByListingId = async (listingId) => {
    try {
        const response = await axios.get(`${baseUrl}/listing/${listingId}`);
        return response.data;
    } catch (error) {
        logApiError(error, 'GET', `${baseUrl}`);

        addToast('Error fetching draft listing', 'error');
        return false;
    }
}

export const createDraftListing = async (data) => {
    try {
        const response = await axios.post(`${baseUrl}`, data);
        addToast('Draft listing created successfully', 'success');
        return response.data;
    } catch (error) {
        logApiError(error, 'POST', `${baseUrl}`, data);
        addToast('Error creating draft listing', 'error');
        return false;
    }
}

export const updateDraftListing = async (id, data) => {
    try {
        const response = await axios.post(`${baseUrl}/${id}`, data);
        addToast('Draft listing updated successfully', 'success');
        return response.data;
    } catch (error) {
        logApiError(error, 'POST', `${baseUrl}/${id}`, data);
        addToast('Error updating draft listing', 'error');
        return false;
    }
}

export const deleteDraftListing = async (id) => {
    try {
        const response = await axios.post(`${baseUrl}/delete/${id}`);
        addToast('Draft listing deleted successfully', 'success');
        return response.data;
    } catch (error) {
        logApiError(error, 'POST', `${baseUrl}/delete/${id}`);
        addToast('Error deleting draft listing', 'error');
        return false;
    }
}
